export const SET_SOW_ENTITY_LIST = "SET_SOW_ENTITY_LIST";
export const SET_SAVED_SOW = "SET_SAVED_SOW";
export const SET_SOW_ALLPRODUCTS = "SET_SOW_ALLPRODUCTS";
export const SET_SOW_PRODUCT = "SET_SOW_PRODUCT";
export const SET_TAB_STATUS = "SET_TAB_STATUS";
export const SET_TAB_INDEX = "SET_TAB_INDEX";
export const SET_SOW_TAB_STATUS = "SET_SOW_TAB_STATUS"
export const SET_SOW_TAB_INDEX = "SET_SOW_TAB_INDEX"
export const RESET_SOW_ENTITIES = "RESET_SOW_ENTITIES"
export const SET_SOW_AGENT = "SET_SOW_AGENT"
export const SET_SOW_PRODUCT_ALL_ACCOUNTS = 'SET_SOW_PRODUCT_ALL_ACCOUNTS'




// WEBPACK FOOTER //
// ./src/components/createASow/actions/actionTypes.js